import { CheckoutActionTypes } from "@swiggy-private/checkout-core";

export const DINE_CASH_POLLING_LOCAL_STORAGE_KEY = "dine_cash_polling_data";

export const DINE_CASH_POOLING_ELIGIBLE_CART_STATES: CheckoutActionTypes[] = [
    CheckoutActionTypes.DINEOUT_BILL_PAYMENT_CART,
];

export enum PoolingMetricsSource {
    CART = "cart",
    POOL_PAGE = "pool_page",
}
